import React, { useState, useRef } from 'react';
import './InfoCardSection.css';

const cardData = [
  { id: 'community', title: 'COMMUNITY', description: 'You are more than just a profile. Join a thriving ecosystem of peers to share insights, collaborate on new ventures, and grow within a universe built for and by creators.' },
  { id: 'opportunity', title: 'OPPORTUNITY', description: 'We connect elite talent with premier projects. Our platform transforms your skills into a meaningful and rewarding career by providing visibility to top-tier clients.' },
  { id: 'creativity', title: 'CREATIVITY', description: 'Our entire platform is designed to eliminate the noise. We give you the freedom and the professional tools to focus on what you do best: creating exceptional work.' }
];

const getCardStatus = (cards, activeId, previousId, cardId) => {
  if (cardId === activeId) return 'active';
  if (cardId === previousId) return 'previous';
  const activeIndex = cards.findIndex(c => c.id === activeId);
  const cardIndex = cards.findIndex(c => c.id === cardId);
  if (cardIndex > activeIndex) return 'inactive-next';
  return 'inactive-previous';
};

const InfoCardSection = () => {
  const [activeId, setActiveId] = useState('community');
  const [previousId, setPreviousId] = useState(null);
  const [cardStyle, setCardStyle] = useState({});
  const cardContainerRef = useRef(null);

  const handleMenuClick = (id) => {
    if (id === activeId) return;
    setPreviousId(activeId);
    setActiveId(id);
    setCardStyle({});
  };

  const handleMouseMove = (e) => {
    if (!cardContainerRef.current) return;
    const { left, top, width, height } = cardContainerRef.current.getBoundingClientRect();
    const x = (e.clientX - left) / width - 0.5;
    const y = (e.clientY - top) / height - 0.5;
    const rotateY = x * 20;
    const rotateX = -y * 20;
    
    const mouseX = ((e.clientX - left) / width) * 100;
    const mouseY = ((e.clientY - top) / height) * 100;
    
    setCardStyle({
      '--mouse-x': `${mouseX}%`,
      '--mouse-y': `${mouseY}%`,
      transform: `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.05)`,
    });
  };
  
  const handleMouseLeave = () => {
    // Correctly reset ONLY the transform, not the mouse position variables
    setCardStyle(prevStyle => ({
      ...prevStyle,
      transform: 'rotateX(0deg) rotateY(0deg) scale(1)',
    }));
  };

  return (
    <section className="info-card-section">
      <nav className="card-menu">
        {cardData.map(item => (
          <button key={item.id} className={`menu-item ${activeId === item.id ? 'active' : ''}`} onClick={() => handleMenuClick(item.id)}>
            {item.title}
          </button>
        ))}
      </nav>
      <div className="card-stack-container" ref={cardContainerRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
        {cardData.map((card) => {
          const status = getCardStatus(cardData, activeId, previousId, card.id);
          return (
            <div key={card.id} className={`info-card ${status}`}>
              <div className="card-transform-wrapper" style={status === 'active' ? cardStyle : {}}>
                <div className="card-content">
                  <h2>{card.title}</h2>
                  <p>{card.description}</p>
                </div>
                <div className="card-illustration">
                  <div className="illustration-placeholder"></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default InfoCardSection;